var show_cta = false;

$(document).on('click','input[type=checkbox][name=chosen_option]', getResult);
function getResult(){
  $.ajax({
    type: "get",
    url: $("#education_pathways_form").attr("href"),
    dataType: "json",
    data : $('#education_pathways_form').serialize(),
    success: function(data){
      $('input[name=chosen_option]').attr("disabled",true);
      if('name' in data){
        if(data['name'] == null){
          var container = $([
            "  <div class='card border-0 my-3'>",
            "    <div class='card-body'>",
            "      <div class='text-center'><img src=" + data["illustration_path"] + " class='pathways-result-illustration w-100' alt='feeling_lost'/></div>",
            "      <h2 class='font-weight-bold'>Feeling Lost?</h2>",
            "      <p class='mb-0'>Having difficulties deciding what suits you? We are here to help. Schedule a free half hour consultation with our admissions expert today!</p>",
            "    </div>",
            "  </div>",
            "  <div class='card border-0 mb-5'>",
            "    <div class='card-body'>",
            "      <div class='text-center'>",
            "        <a href='#' class='btn btn-success btn-pill btn-mblock mb-2 mb-md-0'>Schedule Free Consultation</a>",
            "        <a href='javascript:window.location.reload(true);' class='btn btn-link btn-mblock mb-2 mb-md-0'>Start Over</a>",
            "      </div>",
            "    </div>",
            "  </div>"
          ].join("\n"));
          $(".container.pathways-questions-container").addClass("pb-0");
        }
        else{
          var container = $([
            "  <div class='card border-0 my-3'>",
            "    <div class='card-body'>",
            "      <div class='text-center'><img src=" + data["illustration_path"] + " class='pathways-result-illustration w-100' alt=" + data["name"] + " /></div>",
            "      <h2 class='font-weight-bold'>"+ data["name"] +"</h2>",
            "      <p class='mb-4 mb-md-5'>"+ data["description"] +"</p>",
            "      <h5 class='font-weight-bold'>Career Prospects</h5>",
            "      <p class='mb-0'>"+ data["career"] +"</p>",
            "    </div>",
            "  </div>"
          ].join("\n"));
          $(".container.pathways-questions-container").addClass("pb-0");
          show_cta = true
          var url = $("#discover_courses_cta").attr('href')+"?pathway_subject_id="+ data["id"];
          console.log(url)
          $("#discover_courses_cta").attr('href', url);
        }
      } else {
        var container = $([
          "<div id='question-" + data["id"] + "' class='pathways-bubble-container'>",
          " <div class='pathways-bubble'>",
          "    <div class='pathways-question'>",
          "    </div>",
          "    <div class='pathways-options'>",
          "    </div>",
          " </div>",
          "</div>"
        ].join("\n"));
        $(container).find(".pathways-question").text(data["content"]);
        var answer_options_container = $(container).find('.pathways-options')

        $.each(data["answer_options"], function( index, value ) {
          var answers = $([
            "<div class='row'>",
            "  <div class='col-auto d-flex'>",
            "    <input id='option-"+ value['id'] +"' type='checkbox' name='chosen_option' value="+ value['id'] +" />",
            "    <label for='option-"+ value['id'] +"'>"+ value['content'] +"</label>",
            "  </div>",
            "</div>"
          ].join("\n"));
          answers.appendTo(answer_options_container);
        });
      }
      
      $("#questionaire-container").append(container);
      if(show_cta == true){
        $("#cta-card").show();
      }

      lastElementTop = $(container).offset().top
      scrollAmount = lastElementTop - 120 ;
        $('html, body').animate({
          scrollTop: scrollAmount
        },1000);
      
    }
  });
};

$(document).on('click', '#reload-page', function() {
  show_cta = false;
  $("#cta-card").hide();
  window.location.reload(true);
  window.scrollTo(0,0);
});